import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceComponentProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-component-project-limit',
	path: '/jira/settings/system/performance/metrics/component/projectlimit',
};
